
<template>
  <el-dialog
    class="mall-set"
    width="600px"
    title="商城设置"
    top="20vh"
    :visible.sync="dialogShow"
    :modal-append-to-body="false"
    :close-on-click-modal="false">
    <div v-loading="loading" style="width: 480px; margin: 0 auto">
      <el-form ref="postForm" :model="formData" :rules="formRules" label-position="left" label-width="100px">
        <el-form-item label="商城入口">
          <el-switch v-model="formData.wxapp_shop_enable" :active-value="1" :inactive-value="0" />
        </el-form-item>

        <el-form-item v-if="formData.wxapp_shop_enable" label="客服电话" prop="customer_service_phone">
          <el-input v-model="formData.customer_service_phone" placeholder="请输入有效的客服电话" />
        </el-form-item>
      </el-form>
    </div>

    <div slot="footer" class="flex-center mb">
      <el-button @click="dialogShow = false">取消</el-button>
      <el-button type="primary" @click="submit">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'MallSet',

  props: {
    show: {
      type: Boolean,
      default: false
    }
  },

  data() {
    var checkPhone = (rule, value, callback) => {
      const mobileReg = /^(([1][3,4,5,7,8,9]\d{9})|([0]\d{10,11})|(\d{7,8})|(\d{4}|\d{3})-(\d{7,8}))$/
      const phoneReg = /^\d{3}-\d{8}|\d{4}-\d{7}$/
      if (this.formData.wxapp_shop_enable) {
        if (!value) callback(new Error("客服电话不能为空"))
        if (!mobileReg.test(value) && !phoneReg.test(value)) callback(new Error("请输入有效的客服电话"))
        return callback()
      } else {
        callback();
      }
    };
    return {
      loading: false,
      formData: {},

      formRules: {
        customer_service_phone: [
          { validator: checkPhone, trigger: "blur" },
        ],
      }
    }
  },

  computed: {
    dialogShow: {
      get() {
        return this.show
      },
      set(val) {
        this.$emit('update:show', val)
      }
    }
  },

  created () {
    this.fetchData()
  },

  methods: {
    ...mapActions([
      'setGodCustomizationAction',
      'getCustomizationInfoAction',
    ]),

    fetchData() {
      this.getCustomizationInfoAction().then((res) => {
        this.formData = Object.assign({}, { wxapp_shop_enable: res.data.wxapp_shop_enable, customer_service_phone: res.data.customer_service_phone })
      }).catch(e => {
        console.log(e)
      })
    },

    settingDispatch (data) {
      this.$store.dispatch('setGodCustomizationAction', data).then((res) => {
        this.loading = false
        if (!res.errno) {
          this.$message.success(res.message)
          this.dialogShow = false
        } else {
          this.$message.error(res.message)
        }
      }).catch((err) => {
        console.error(err)
      })
    },

    submit() {
      this.$refs['postForm'].validate((valid) => {
        if (valid) {
          this.loading = true
          this.settingDispatch(this.formData)
        }
      })
    }

  }
}
</script>

